export enum UserType {
  STAFF = "1",
  PROJECT_MANAGERS = "2",
  HUMAN_RESOURCES = "3",
  BUSINESS_LEADERS = "4",
  INFRASTRUCTURE_TEAM = "5",
  ACCOUNT = "6",
  USER = "e",
  VENDOR = "v",
}

export enum UserTypeName {
  STAFF = "Employee / Organizational Staff",
  PROJECT_MANAGERS = "Project Manager",
  HUMAN_RESOURCES = "Human Resource",
  BUSINESS_LEADERS = "Business Head",
  INFRASTRUCTURE_TEAM = "Infrastructure Team",
  ACCOUNT = "Account",
  NOTDEFINED = "Not Defined"
}
